import { t } from '@lingui/core/macro';
import { formatIntacctEntityName as format } from '@sit/client-shared';
import type { UserEntity } from '@sit/openapi';

type ArgType = Pick<UserEntity, 'intacctEntityId' | 'name'>;

export function formatIntacctEntityName(entity: ArgType | undefined, fallback?: string) {
  return format(entity, fallback ?? t`Top level`);
}
